import React, {Component} from 'react';

export default class ListViewer extends Component {

  render() {
    const {value, placeholder} = this.props;

    return (
      <ul className="list-viewer">
        {value.length > 0 && value.map((item, index) => {
          return <li key={index} className="list-viewer-items">{item}</li>
        })}
        {value.length === 0 && placeholder.map((item, index) => {
          return <li key={index} className="list-viewer-items placeholder">{item}</li>
        })}
      </ul>
    );
  }
}


// WEBPACK FOOTER //
// ./client/pages/persona/listField/ListViewer.jsx